/**
 * The day Deck opens to everyone who signed up. The landing's last screen, its calendar event, the reminder
 * people save in their AI and the sign-in gate (`~/lib/opening.server`) all read it from here, so it changes
 * in one place.
 */
export const LAUNCH = { day: '2026-10-19', weekday: 'Monday', label: 'Monday, October 19' };
